import { render, staticRenderFns } from "./collectInfo.vue?vue&type=template&id=2e47c44c&scoped=true"
import script from "./collectInfo.vue?vue&type=script&lang=js"
export * from "./collectInfo.vue?vue&type=script&lang=js"
import style0 from "./collectInfo.vue?vue&type=style&index=0&id=2e47c44c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e47c44c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e47c44c')) {
      api.createRecord('2e47c44c', component.options)
    } else {
      api.reload('2e47c44c', component.options)
    }
    module.hot.accept("./collectInfo.vue?vue&type=template&id=2e47c44c&scoped=true", function () {
      api.rerender('2e47c44c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/collectInfo.vue"
export default component.exports